import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Zap, Target, Leaf } from 'lucide-react';
export function ValueProposition() {
  const benefits = [{
    icon: <Sun className="w-6 h-6 text-brand-green" data-id="element-171" />,
    title: 'Bienestar diario',
    text: 'Apoya una rutina más equilibrada y consciente.'
  }, {
    icon: <Zap className="w-6 h-6 text-brand-green" data-id="element-172" />,
    title: 'Energía y vitalidad',
    text: 'Cordyceps es una opción valorada por quienes buscan acompañar su energía diaria.'
  }, {
    icon: <Target className="w-6 h-6 text-brand-green" data-id="element-173" />,
    title: 'Enfoque y claridad',
    text: 'Melena de León se asocia a rutinas de concentración y claridad mental.'
  }, {
    icon: <Leaf className="w-6 h-6 text-brand-green" data-id="element-174" />,
    title: 'Equilibrio natural',
    text: 'Reishi es usado tradicionalmente en rutinas de calma, descanso y bienestar general.'
  }];
  return <section className="py-20 bg-brand-green text-brand-cream relative overflow-hidden" data-id="element-175">
      {/* Subtle background texture/pattern could go here */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white to-transparent" data-id="element-176"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-177">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-178">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-179">
            <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6 text-brand-beige" data-id="element-180">
              Una fórmula natural para acompañar tu bienestar
            </h2>
            <p className="text-lg text-brand-cream/80 leading-relaxed mb-8" data-id="element-181">
              Nuestros extractos combinan hongos funcionales reconocidos por su
              uso tradicional en rutinas de bienestar. Cada fórmula está pensada
              para acompañar distintos objetivos: equilibrio, energía, enfoque y
              vitalidad.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-182">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-brand-lightGreen/40 backdrop-blur-sm p-6 rounded-2xl border border-brand-lightGreen/50" data-id="element-183">
                <div className="w-12 h-12 bg-brand-beige rounded-full flex items-center justify-center mb-4" data-id="element-184">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-heading font-bold mb-2 text-brand-beige" data-id="element-185">
                  {benefit.title}
                </h3>
                <p className="text-sm text-brand-cream/80" data-id="element-186">{benefit.text}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}